import { render, staticRenderFns } from "./TabEmployee.vue?vue&type=template&id=bfbb0e20&scoped=true&"
import script from "./TabEmployee.vue?vue&type=script&lang=js&"
export * from "./TabEmployee.vue?vue&type=script&lang=js&"
import style0 from "./TabEmployee.vue?vue&type=style&index=0&id=bfbb0e20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfbb0e20",
  null
  
)

export default component.exports